import React from 'react';

import { sendUsageEvent } from '~src/spacesPlatform/hooks/useUsage';

import { GuidedOnboardingBannerService, WelcomeBannerFeatureName } from '../services/GuidedOnboardingBannerService';

interface GuidedOnboardingFilmStripNavigationButtonProps {
    onClick: () => void;
    testId: string;
    className: string;
    alt: string;
    Icon: React.ComponentType<{ size: 12 | 14 | 22 | 36, alt?: string, className?: string }>;
    usageEventClickType: string;
}

export const GuidedOnboardingFilmStripNavigationButton = React.forwardRef<HTMLButtonElement, GuidedOnboardingFilmStripNavigationButtonProps>(({
    onClick,
    testId,
    className,
    alt,
    Icon,
    usageEventClickType
}, ref): JSX.Element => {
    const clickHandler = () => {
        GuidedOnboardingBannerService.instance.bannerLayoutChanged.trigger();
        sendUsageEvent(WelcomeBannerFeatureName, 'click_through', {
            a: usageEventClickType
        });

        onClick();
    };

    return (
        <button
            ref={ref}
            onClick={clickHandler}
            data-tb-test-id={testId}
            className={className}
        >
            <Icon size={22} alt={alt} />
        </button>
    );
});
